import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const CircleUnCheckSvg = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22.3217C6.477 22.3217 2 17.8447 2 12.3217C2 6.79866 6.477 2.32166 12 2.32166C17.523 2.32166 22 6.79866 22 12.3217C22 17.8447 17.523 22.3217
       12 22.3217ZM12 10.9077L9.172 8.07866L7.757 9.49366L10.586 12.3217L7.757 15.1497L9.172 16.5647L12 13.7357L14.828 16.5647L16.243 15.1497L13.414
        12.3217L16.243 9.49366L14.828 8.07866L12 10.9077Z"
      fill="#E32D23"
    />
  </svg>
);

const CircleUnCheck = (props: IIconProps) => <Icon component={CircleUnCheckSvg} {...props} />;

export default CircleUnCheck;
